import React, { useState } from 'react';
import styled from 'styled-components';
import * as BuilderUI from '../../../BuilderUI';
import {
  IRowMeta,
  setMergeEventAlias,
} from '../../../../../redux/slices/oldBuilder';
import { useAppDispatch } from '../../../../../redux/hooks';
import { InputField } from '../../../../Form';
import { MAX_MERGE_EVENT_ALIAS_LENGTH } from '../../../../../config/constants';
import toastMessage from '../../../../../utils/toastMessage';
import { SquareAddButton, SquareRemoveButton } from '../../../../Button';

interface IProps {
  rowMeta: IRowMeta;
  name: string | null;
  isNameAutoGenerated: boolean;
}

const Container = styled(BuilderUI.BuilderFieldContainer)`
  align-self: flex-start;
  min-height: 28px;
  margin-top: 4px;
`;

const MergeEventAlias = ({ rowMeta, isNameAutoGenerated, name }: IProps) => {
  const [showAlias, setShowAlias] = useState(!isNameAutoGenerated);

  const dispatch = useAppDispatch();

  const { rowIndex } = rowMeta;

  const updateAlias = (newAlias: string) => {
    if (newAlias.length > MAX_MERGE_EVENT_ALIAS_LENGTH) {
      toastMessage({
        message: `Alias cannot exceed ${MAX_MERGE_EVENT_ALIAS_LENGTH} characters.`,
        type: 'error',
      });
      return;
    }

    dispatch(setMergeEventAlias({ rowIndex, newAlias }));
  };

  const handleRemoveAlias = () => {
    setShowAlias(false);

    if (name) {
      updateAlias('');
    }
  };

  return (
    <Container>
      <BuilderUI.BuilderFieldLabel>Alias</BuilderUI.BuilderFieldLabel>
      {showAlias ? (
        <>
          <InputField
            autoFocus={!Boolean(name)}
            value={name || ''}
            onChange={updateAlias}
          />
          <SquareRemoveButton onClick={handleRemoveAlias} />
        </>
      ) : (
        <SquareAddButton onClick={() => setShowAlias(true)} />
      )}
    </Container>
  );
};

export default MergeEventAlias;
